import api from "../api/axios"

export const getExpenseTypes = () => api.get("/expense-types").then((r) => r.data)
export const createExpenseType = (data) => api.post("/expense-types", data).then((r) => r.data)
export const updateExpenseType = (id, data) => api.put(`/expense-types/${id}`, data).then((r) => r.data)
export const deleteExpenseType = (id) => api.delete(`/expense-types/${id}`).then((r) => r.data)
